import EA from '../helpers/init';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { animWordsHelper, splitTextToWords } from './animHelpers';

gsap.registerPlugin(ScrollTrigger);
export default EA.Methods.animText = ($this) => {
    const textEls = $this.querySelectorAll(
        '.user-content.anim-text p, .anim-text:not(.user-content)'
    );

    const wordsSplit = splitTextToWords(textEls);

    let titleOffset = $this.getAttribute('data-title-offset') || '0';
    if (window.innerWidth < 600) titleOffset = '0';

    const autoplay = $this.getAttribute('data-autoplay') || false;

    if(window.innerWidth < 600) {
        titleOffset = '0';
    }

    document.fonts.ready.then(() => {
        const init = function () {
            let tl = gsap.timeline(
                autoplay ? {} : {
                    scrollTrigger: {
                        trigger: $this,
                        start: `top+=${titleOffset} center`,
                        end: 'top+=500 60%',
                        // markers: true,
                        once: true,
                    },
                }
            );

            tl = animWordsHelper(tl, { words: wordsSplit });
        };

        if(autoplay) {
            init();
            return;
        }

        const intersectionObserver = new IntersectionObserver((entries) => {
            const entry = entries[0];

            if (!entry.isIntersecting) return;
            intersectionObserver.disconnect();
            init();
            ScrollTrigger.refresh();
        },
        {
            root: null,
            threshold: 0,
            rootMargin: '100px',
        });

        intersectionObserver.observe($this);
    });
};
